import { Button, Result } from 'antd'
import { FC } from 'react'

interface ErrorFallbackProps {
  error: Error
  resetError: () => void
}

export const ProductionErrorFallback: FC<ErrorFallbackProps> = ({
  resetError,
}) => {
  const handleGoHome = () => {
    window.location.href = '/'
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <Result
        status="500"
        title="Something went wrong"
        subTitle="We're sorry, but something unexpected happened. Our team has been notified and is working on it."
        extra={[
          <Button type="primary" key="reload" onClick={resetError}>
            Reload Page
          </Button>,
          <Button key="home" onClick={handleGoHome}>
            Go to Homepage
          </Button>,
        ]}
      />
    </div>
  )
}

export const DevelopmentErrorFallback: FC<ErrorFallbackProps> = ({
  error,
  resetError,
}) => {
  return (
    <div
      role="alert"
      style={{ padding: '20px', fontFamily: 'monospace', lineHeight: '1.6' }}
    >
      <h2 style={{ color: 'red' }}>Something went wrong:</h2>
      <pre style={{ color: 'red', overflow: 'auto' }}>
        <strong>{error.message}</strong>
      </pre>
      <pre style={{ color: 'red', overflow: 'auto' }}>{error.stack}</pre>
      <Button type="primary" onClick={resetError} style={{ marginTop: '20px' }}>
        Try again
      </Button>
    </div>
  )
}
